// Auto-generated from lib/i18n.js (mechanical split — do not hand-reorder).
// Namespace "common" base dictionary. New keys for feature batches go in sibling
// fragment files, merged in ./index.js — not here.
export default {
  "fr": {
      "language": "Langue",
      "lang.fr": "Français",
      "lang.en": "English",
      "lang.es": "Español",
      "actions.save": "Enregistrer",
      "actions.cancel": "Annuler",
      "actions.delete": "Supprimer",
      "actions.edit": "Modifier",
      "actions.create": "Créer",
      "actions.close": "Fermer",
      "actions.search": "Rechercher",
      "actions.loading": "Chargement…",
      "actions.logout": "Déconnexion",
      "actions.back": "Retour",
      "common.email": "Courriel",
      "common.name": "Nom",
      "common.required": "Requis",
      "errors.siteNotFoundTitle": "Site introuvable",
      "errors.siteNotFoundBody": "Cette adresse n’est associée à aucun site actif.",
      "errors.siteUnavailableTitle": "Ce site est temporairement indisponible",
      "errors.siteUnavailableBody": "Merci de revenir dans quelques instants.",
      "errors.tenantSuspended": "Ce cabinet est suspendu — les modifications ne peuvent pas être enregistrées tant qu’il n’est pas réactivé.",
      "errors.practiceDeletionPending": "Ce cabinet est en cours de suppression : aucun paiement ne peut être ouvert pour lui.",
      "errors.addressRetired": "Cette adresse appartenait à un cabinet supprimé : elle ne peut plus jamais être utilisée. Choisissez-en une autre.",
      "errors.addressDeletionPending": "Ce cabinet est en cours de suppression : son adresse ne peut pas changer.",
      "errors.ownerTenantMismatch": "Ce compte n’est pas propriétaire du cabinet que cette page administre.",
      "errors.tenantSelectionRequired": "Vous possédez plusieurs cabinets — choisissez celui sur lequel travailler.",
      "errors.invalidFieldValue": "Valeur invalide",
      "errors.quizTitleRequired": "Chaque quiz doit avoir un titre : ouvrez le cours et nommez son quiz avant d’enregistrer.",
      "errors.courseInPathway": "Ce cours est utilisé par ces parcours : {pathways}. Retirez d’abord l’étape de cours ou archivez ces parcours.",
      "errors.courseHasNoLessons": "Un cours publié doit contenir au moins une leçon. Ajoutez une leçon ou dépubliez d’abord le cours.",
      "errors.currencyNotSettleable": "La plateforme encaisse dans une seule devise : ce prix ne peut pas être enregistré dans une autre. Utilisez la devise indiquée."
  },
  "en": {
      "language": "Language",
      "lang.fr": "Français",
      "lang.en": "English",
      "lang.es": "Español",
      "actions.save": "Save",
      "actions.cancel": "Cancel",
      "actions.delete": "Delete",
      "actions.edit": "Edit",
      "actions.create": "Create",
      "actions.close": "Close",
      "actions.search": "Search",
      "actions.loading": "Loading…",
      "actions.logout": "Logout",
      "actions.back": "Back",
      "common.email": "Email",
      "common.name": "Name",
      "common.required": "Required",
      "errors.siteNotFoundTitle": "Site not found",
      "errors.siteNotFoundBody": "This address is not linked to any active site.",
      "errors.siteUnavailableTitle": "This site is temporarily unavailable",
      "errors.siteUnavailableBody": "Please check back in a few moments.",
      "errors.tenantSuspended": "This practice is suspended — changes cannot be saved until it is reactivated.",
      "errors.practiceDeletionPending": "This practice is being deleted: no payment can be opened for it.",
      "errors.addressRetired": "This address belonged to a practice that was deleted, and it can never be used again. Please choose another.",
      "errors.addressDeletionPending": "This practice is being deleted: its address cannot change.",
      "errors.ownerTenantMismatch": "This account does not own the practice this page is acting for.",
      "errors.tenantSelectionRequired": "You own several practices — choose the one to work on.",
      "errors.invalidFieldValue": "Invalid value",
      "errors.quizTitleRequired": "Every quiz needs a title — open the course and name its quiz before saving.",
      "errors.courseInPathway": "These pathways use this course: {pathways}. Remove the course step or archive those pathways first.",
      "errors.courseHasNoLessons": "A published course needs at least one lesson. Add a lesson, or unpublish the course first.",
      "errors.currencyNotSettleable": "This platform charges in a single currency: this price cannot be saved in another one. Use the currency shown."
  },
  "es": {
      "language": "Idioma",
      "lang.fr": "Français",
      "lang.en": "English",
      "lang.es": "Español",
      "actions.save": "Guardar",
      "actions.cancel": "Cancelar",
      "actions.delete": "Eliminar",
      "actions.edit": "Editar",
      "actions.create": "Crear",
      "actions.close": "Cerrar",
      "actions.search": "Buscar",
      "actions.loading": "Cargando…",
      "actions.logout": "Cerrar sesión",
      "actions.back": "Volver",
      "common.email": "Correo",
      "common.name": "Nombre",
      "common.required": "Requerido",
      "errors.siteNotFoundTitle": "Sitio no encontrado",
      "errors.siteNotFoundBody": "Esta dirección no está asociada a ningún sitio activo.",
      "errors.siteUnavailableTitle": "Este sitio no está disponible temporalmente",
      "errors.siteUnavailableBody": "Vuelve a intentarlo en unos instantes.",
      "errors.tenantSuspended": "Esta consulta está suspendida: los cambios no se pueden guardar hasta que se reactive.",
      "errors.practiceDeletionPending": "Esta consulta se está eliminando: no se puede abrir ningún pago para ella.",
      "errors.addressRetired": "Esta dirección pertenecía a una consulta eliminada y no se puede volver a usar nunca. Elija otra.",
      "errors.addressDeletionPending": "Esta consulta se está eliminando: su dirección no puede cambiar.",
      "errors.ownerTenantMismatch": "Esta cuenta no es propietaria de la consulta que administra esta página.",
      "errors.tenantSelectionRequired": "Tienes varias consultas: elige aquella en la que quieres trabajar.",
      "errors.invalidFieldValue": "Valor inválido",
      "errors.quizTitleRequired": "Cada quiz necesita un título: abre el curso y ponle nombre a su quiz antes de guardar.",
      "errors.courseInPathway": "Estos itinerarios usan este curso: {pathways}. Quita primero el paso del curso o archiva esos itinerarios.",
      "errors.courseHasNoLessons": "Un curso publicado necesita al menos una lección. Añade una lección o despublica primero el curso.",
      "errors.currencyNotSettleable": "La plataforma cobra en una sola moneda: este precio no se puede guardar en otra. Usa la moneda indicada."
  },
};
